import axios from 'axios';

export async function getDashboardStatistics(token) {
    const res = await axios.get('/api/Dashboard/GetDashboardStatistics', getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

export async function getFullDashboard(token, signal?: AbortSignal) {
    const res = await axios.get('/api/Dashboard/GetFullDashboard', { ...getHeaders(token), signal });
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

export async function getServiceOverview(token) {
    const res = await axios.get('/api/Dashboard/GetServiceOverview', getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

const getHeaders = (token) => {
    return {
        timeout: 30000,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    };
};
